
const translation = window['langArr'][window['language']];

var responseHandler = {
    test : function() {
        console.log("Test global handler helper.")
    },
    gameGet: {},
    gameResults: {}
};

function jackpot() {

    var self = this;

    // reset canvas before drawing screen
    canvas.reset();

    mode = 'regular_game';

    // replace video
    var video = document.getElementById('myvideo');
    video.style.display = 'none';

    // replace video
    var video = document.getElementById('myvideo');
    var source = document.getElementById('videosource');

    video.style.display = 'none';
    video.pause();
    source.src = 'video/' + mode + '.mp4';

    video.load();
    window['playLuckyBallsVideo'](video);

    this.loadVideo = function() {
        if (video.readyState === 4) {
            video.style.display = 'block';
        } else {
            setTimeout(self.loadVideo, 200);
        }
    }
    this.loadVideo();

    // Game play elements
    scene.add(
            new classImage()
            .setX(0)
            .setY(0)
            .setAnimation({
                loopFrom: 10,
                show: true,
                stop: false,
                sequences: images.jackpot,
                speed: 1,
            }),
            'jackpot_animation'
            );

    /**
     * @description Draw elements adding to the scene.
     */
    scene.add(
            new classImage(images[mode + '_header'])
            .setX(0)
            .setY(0)
            .setWidth(750)
            .setHeight(46),
            'header'
            );

    scene.add(
            new classText()
            .setX(280)
            .setY(300)
            .setFontSize('58px')
            .setFontFamily('FuturaHeavy')
            .setColor('yellow')
            .setText(state.jackpot),
            'results'
            );
}

/**
 * Checks for jackpot and if exists creates jackpotObj global obj with jackpot details.
 * 
 * @param {*} resp 
 */
const checkForJackpot = (resp) => {
    if (typeof resp === 'object' && Object.keys(resp).length) {
        if ('GameJackPotCode' in resp && "Bingo_JackpotValue" in resp) {
            //resp.GameJackPotCode = 'NUTO' // hardcoded 4 test purposes delete after
            if (resp.GameJackPotCode) {
                // forming global jackpotObj
                window['jackpotObj'] = {
                    jackpotCode: resp.GameJackPotCode,
                    jackpotValue: resp.Bingo_JackpotValue
                    // regionJackpotValue: resp.Region_JackpotValue || "Not activated"
                } 

            }
        }
    }
}

/**
 * Shows Jackpot event above video screen.
 * 
 * @param {*} jackPotDetails 
 */
const showJackpotEvent = (jackPotDetails) => {
    // Show jackpot div
    document.querySelector('.jackpot-informer').style.display = 'flex';
    // Set JACKPOT VALUE AND CODE
    document.getElementById('lbJackpotValue').innerHTML = jackPotDetails.jackpotValue;
    document.getElementById('lbJackpotCode').innerHTML = jackPotDetails.jackpotCode;
}

// Listen for the showJackpotEvent event.
window.addEventListener('showJackpotEvent', function (data) {
    showJackpotEvent(data.detail);
}, false);

window['results'] = function() {

    var self = this;

    // reset canvas before drawing screen
    canvas.reset();

    var loadedOnce = window['loadedOnce'];

    // if loaded first time - get tickets
    if(typeof loadedOnce === 'undefined') {
        window['loadedOnce'] = 1;
        var ticketsEvent = new CustomEvent("get_tickets");
        window.dispatchEvent(ticketsEvent);
    }

    mode = 'regular_game';

    // replace video
    var video = document.getElementById('myvideo');
    var source = document.getElementById('videosource');

    video.style.display = 'none';
    video.pause();
    source.src = 'video/' + mode + '.mp4';

    video.load();
    window['playLuckyBallsVideo'](video);

    this.loadVideo = function() {
        if (video.readyState === 4) {
            video.style.display = 'block';
        } else {
            setTimeout(self.loadVideo, 200);
        }
    }
    this.loadVideo();

    /**
     * @description Draw elements adding to the scene.
     */
    scene.add(
            new classImage(images[mode + '_header'])
            .setX(0)
            .setY(0)
            .setWidth(750)
            .setHeight(46),
            'header'
            );

    scene.add(
            new classImage(images[mode + '_footer'])
            .setX(0)
            .setY(420)
            .setWidth(750)
            .setHeight(21),
            'footer'
            );

    scene.add(new classText()
            .setX(15)
            .setY(435)
            .setFontSize('10px')
            .setFontFamily('FuturaHeavy')
            .setText(langArr[language].preballs_sum)
            .setColor('#00cfff'),
        'preballs_sum_label'
    );

    scene.add(new classText()
            .setX(350)
            .setY(435)
            .setFontSize('10px')
            .setFontFamily('FuturaHeavy')
            .setText(langArr[language].odd)
            .setColor('#00cfff'),
        'odd_footer_label'
    );

    scene.add(new classText()
            .setX(374)
            .setY(435)
            .setFontSize('10px')
            .setFontFamily('FuturaHeavy')
            .setText('/')
            .setColor('#00cfff'),
        'odd_even_footer_delimiter'
    );

    scene.add(new classText()
            .setX(383)
            .setY(435)
            .setFontSize('10px')
            .setFontFamily('FuturaHeavy')
            .setText(langArr[language].even)
            .setColor('#00cfff'),
        'even_footer_label'
    );

    scene.add(new classText()
            .setX(625)
            .setY(435)
            .setFontSize('10px')
            .setFontFamily('FuturaHeavy')
            .setText(langArr[language].bonus_numbers)
            .setColor('#00cfff'),
        'bonus_footer_label'
    );

    scene.add(
            new classText()
            .setX(320)
            .setY(38)
            .setFontSize('28px')
            .setFontFamily('FuturaHeavy')
            .setColor('yellow')
            .setText(langArr[language].results),
            'results'
            );

    scene.add(
            new classText()
            .setX(320)
            .setY(48)
            .setFontSize('11px')
            .setFontFamily('FuturaHeavy')
            .setColor('yellow')
            .setText(langArr[language].round_completed),
            'round_completed'
            );

    scene.add(
            new classText()
            .setX(300)
            .setY(65)
            .setFontSize('10px')
            .setFontFamily('FuturaHeavy')
            .setColor('white')
            .setText(langArr[language].first_5_no_award),
            'first_five_without_award'
            );

    var x = 120;
    var y = 120;

    var points = {
        "point_0": [253, 65, "", "", true],
        "point_1": [301, 65, "", "", true],
        "point_2": [348, 65, "", "", true],
        "point_3": [395, 65, "", "", true],
        "point_4": [442, 65, "", "", true],
        "point_5": [x, y, "right", "10.000", true],
        "point_6": [x, y + 48, "right", "7.500", true],
        "point_7": [x, y + 48 * 2, "right", "5.000", true],
        "point_8": [x, y + 48 * 3, "right", "2.500", true],
        "point_9": [x, y + 48 * 4, "right", "1.000", true],
        "point_10": [x, y + 48 * 5, "right", "500", true],
        "point_11": [x + 115, y, "right", "300", true],
        "point_12": [x + 115, y + 48, "right", "200", true],
        "point_13": [x + 115, y + 48 * 2, "right", "150", true],
        "point_14": [x + 115, y + 48 * 3, "right", "100", true],
        "point_15": [x + 115, y + 48 * 4, "right", "90", true],
        "point_16": [x + 115, y + 48 * 5, "right", "80", true],
        "point_17": [x + 115 * 2, y, "right", "70", true],
        "point_18": [x + 115 * 2, y + 48, "right", "60", true],
        "point_19": [x + 115 * 2, y + 48 * 2, "right", "50", true],
        "point_20": [x + 115 * 2, y + 48 * 3, "right", "40", true],
        "point_21": [x + 115 * 2, y + 48 * 4, "right", "30", true],
        "point_22": [x + 115 * 2, y + 48 * 5, "right", "25", true],
        "point_23": [x + 115 * 3, y, "right", "20", true],
        "point_24": [x + 115 * 3, y + 48, "right", "15", true],
        "point_25": [x + 115 * 3, y + 48 * 2, "right", "10", true],
        "point_26": [x + 115 * 3, y + 48 * 3, "right", "9", true],
        "point_27": [x + 115 * 3, y + 48 * 4, "right", "8", true],
        "point_28": [x + 115 * 3, y + 48 * 5, "right", "7", true],
        "point_29": [x + 115 * 4, y, "right", "6", true],
        "point_30": [x + 115 * 4, y + 48, "right", "5", true],
        "point_31": [x + 115 * 4, y + 48 * 2, "right", "4", true],
        "point_32": [x + 115 * 4, y + 48 * 3, "right", "3", true],
        "point_33": [x + 115 * 4, y + 48 * 4, "right", "2", true],
        "point_34": [x + 115 * 4, y + 48 * 5, "right", "1", true]
    };

    oddNumbersHolders = new Array();
    for (var x = 320; x > 320 - (18 * 11); x -= 11) {
        oddNumbersHolders.push(new classOddEven()
                .setX(x)
                .setY(425)
                );
        
        scene.add(new classImage(images[mode + '_hole'])
                .setX(x)
                .setY(425),
                'hole_' + x
                );
    }

    evenNumbersHolders = new Array();
    for (var x = 420; x < 420 + (18 * 11); x += 11) {
        evenNumbersHolders.push(new classOddEven()
                .setX(x)
                .setY(425)
                );
        
        scene.add(new classImage(images[mode + '_hole'])
                .setX(x)
                .setY(425),
                'hole_' + x
                );        
    }

    shownBalls = 0;
    drawnOddBalls = 0;
    drawnEvenBalls = 0;
    shownColorBetting = 0;

    for (var key in points) {
        if (typeof points[key] === 'object')
            scene.add(
                    new classPointsResults()
                    .setDrumPoint(points[key][4])
                    .setText(points[key][3])
                    .setTextOrientation(points[key][2])  // must be executed before setImageX and setImageY
                    .setImage(images[mode + '_ball_holder'])
                    .setImageSize(54)
                    .setImageX(points[key][0])
                    .setImageY(points[key][1]),
                    key // important!
                    );
    }

    // show odd counter
    scene.add(new classText()
            .setX(334)
            .setY(435)
            .setFontSize('11px')
            .setFontFamily('FuturaHeavy')
            .setText('0'),
            'odd_counter');

    // show even counter
    scene.add(new classText()
            .setX(405)
            .setY(435)
            .setFontSize('11px')
            .setFontFamily('FuturaHeavy')
            .setText('0'),
            'even_counter');

    for (var id in window['drawnNumbers']) {
        scene.elements['point_' + id].appendBall(window['drawnNumbers'][id]);
    }

    scene.add(
            new classImage()
            .setX(161)
            .setY(58)
            .setWidth(100)
            .setHeight(60)
            .setAnimation({
                show: true,
                stop: false,
                sequences: images.infobox,
                speed: 1,
            }),
            'infobox1'
            );

    scene.add(new classText()
            .setX(186)
            .setY(72)
            .setFontSize('11px')
            .setFontFamily('FuturaHeavy')
            .setText(langArr[language].round_no),
            'infoText1'
            );

    scene.add(
            new classImage()
            .setX(488)
            .setY(58)
            .setWidth(100)
            .setHeight(60)
            .setAnimation({
                show: true,
                stop: false,
                sequences: images.infobox,
                speed: 1,
            }),
            'infobox2'
            );

    scene.add(new classText()
            .setX(506)
            .setY(72)
            .setFontSize('11px')
            .setFontFamily('FuturaHeavy')
            .setText(langArr[language].jackpot_code),
            'infoText2'
            );

    if(typeof bonusNumbers === 'undefined') bonusNumbers = new Array();

    // show bonus numbers
    scene.add(new classText()
            .setX(703)
            .setY(435)
            .setFontSize('11px')
            .setFontFamily('FuturaHeavy')
            .setText(bonusNumbers),
            'bonus_numbers');

    // show jackpot code
    scene.add(new classText()
            .setX(514)
            .setY(95)
            .setFontSize('19px')
            .setFontFamily('FuturaHeavy')
            .setColor('#FFFF8A')
            .setText(state.GameJackPotCode),
            'jackpotCode'
            );

    scene.add(new classText()
            .setX(192)
            .setY(95)
            .setFontSize('19px')
            .setFontFamily('FuturaHeavy')
            .setColor('#FFFF8A')
            .setText(state.roundid_today),
            'roundNo'
            );
}

window['betScreen'] = function(delay) {

    window['loadedOnce'] = 1;

    var self = this;

    // reset canvas before drawing screen
    canvas.reset();

    window['mode'] = 'regular_game';

    if (typeof delay === 'undefined') {
        var delay = 15;
    }
    var videoDuration = 120; // 2 mins
    var startTime = videoDuration - delay;
    var counterStartTime = videoDuration - startTime;

    game.reset();
    var ticketsEvent = new CustomEvent("get_tickets");
    window.dispatchEvent(ticketsEvent);

    // replace video
    var video = document.getElementById('myvideo');
    var source = document.getElementById('videosource');

    video.style.display = 'none';
    video.pause();
    source.src = 'video/intro_'+ language +'.mp4';

    video.addEventListener('loadedmetadata', function() {
        this.currentTime = startTime - 1;
    }, false);
    video.load();
    window['playLuckyBallsVideo'](video);
    video.style.display = 'block';

    this.loadVideo = function() {
        if (video.readyState === 4) {
            countdown(counterStartTime);
        } else {
            setTimeout(self.loadVideo, 200);
        }
    }
    this.loadVideo();
    
    /**
     * @description Draw elements adding to the scene.
     */
    scene.add(
            new classImage(images.header_intro)
            .setX(0)
            .setY(0)
            .setWidth(750)
            .setHeight(46),
            'header'
            );

    scene.add(
            new classText()
            .setX(362)
            .setY(20)
            .setFontSize('18px')
            .setFontFamily('FuturaHeavy')
            .setColor('yellow')
            .setText(''),
            'countdown'
            );
}

window.gameProgress = function(gameMode) {

    window['loadedOnce'] = 1;
    window['mode'] = gameMode;
    var self = this;
    // document.getElementById('background').style.backgroundImage = "url('img/" + mode + "/background.png')"
    // replace video
    var video = document.getElementById('myvideo');
    var source = document.getElementById('videosource');

    video.style.display = 'none';
    video.pause();
    source.src = './video/' + mode + '.mp4';
    video.load();
    window['playLuckyBallsVideo'](video);
    this.loadVideo = function() {
        if (video.readyState === 4) {
            video.style.display = 'block';
        } else {
            setTimeout(self.loadVideo, 200);
        }
    }
    this.loadVideo();
    
    // reset canvas before drawing screen
    
    canvas.reset();
 

    scene.add(
            new classImage(images[mode + '_header'])
            .setX(0)
            .setY(0)
            .setWidth(750)
            .setHeight(46),
            'header'
            );

    scene.add(
            new classImage(images[mode + '_footer'])
            .setX(0)
            .setY(420)
            .setWidth(750)
            .setHeight(21),
            'footer'
            );

    scene.add(new classText()
            .setX(15)
            .setY(435)
            .setFontSize('10px')
            .setFontFamily('FuturaHeavy')
            .setText(langArr[language].preballs_sum)
            .setColor('#00cfff'),
        'preballs_sum_label'
    );

    scene.add(new classText()
            .setX(350)
            .setY(435)
            .setFontSize('10px')
            .setFontFamily('FuturaHeavy')
            .setText(langArr[language].odd)
            .setColor('#00cfff'),
        'odd_footer_label'
    );

    scene.add(new classText()
            .setX(374)
            .setY(435)
            .setFontSize('10px')
            .setFontFamily('FuturaHeavy')
            .setText('/')
            .setColor('#00cfff'),
        'odd_even_footer_delimiter'
    );

    scene.add(new classText()
            .setX(383)
            .setY(435)
            .setFontSize('10px')
            .setFontFamily('FuturaHeavy')
            .setText(langArr[language].even)
            .setColor('#00cfff'),
        'even_footer_label'
    );


    scene.add(new classText()
            .setX(625)
            .setY(435)
            .setFontSize('10px')
            .setFontFamily('FuturaHeavy')
            .setText(langArr[language].bonus_numbers)
            .setColor('#00cfff'),
        'bonus_footer_label'
    );

    scene.add(
            new classImage(images.drum_frame)
            .setX(250)
            .setY(16)
            .setWidth(250)
            .setHeight(273),
            'frame'
            );

    scene.add(
            new classImage()
            .setX(291)
            .setY(78)
            .setWidth(167)
            .setHeight(167)
            .setAnimation({
                show: true,
                stop: false,
                sequences: images.drum_loop,
                speed: 1,
            }),
            'drum'
            );

    scene.add(
            new classImage()
            .setX(161)
            .setY(58)
            .setWidth(100)
            .setHeight(60)
            .setAnimation({
                show: true,
                stop: false,
                sequences: images.infobox,
                speed: 1,
            }),
            'infobox1'
            );

    scene.add(new classText()
            .setX(186)
            .setY(72)
            .setFontSize('11px')
            .setFontFamily('FuturaHeavy')
            .setText(langArr[language].round_no),
            'infoText1'
            );

    scene.add(
            new classImage()
            .setX(488)
            .setY(58)
            .setWidth(100)
            .setHeight(60)
            .setAnimation({
                show: true,
                stop: false,
                sequences: images.infobox,
                speed: 1,
            }),
            'infobox2'
            );


    scene.add(new classText()
            .setX(506)
            .setY(72)
            .setFontSize('11px')
            .setFontFamily('FuturaHeavy')
            .setText(langArr[language].jackpot_code),
            'infoText2'
            );

    scene.add(
            new classImage(images.color_betting)
            .setX(620)
            .setY(55),
            'color_betting'
            );

    var points = {
        "point_0": [253, 67, "right", "", false],
        "point_1": [295, 33, "right", "", false],
        "point_2": [348, 20, "right", "", false],
        "point_3": [401, 33, "right", "", false],
        "point_4": [442, 67, "right", "", false],
        "point_5": [15, 75, "right", "10.000", true],
        "point_6": [15, 123, "right", "7.500", true],
        "point_7": [15, 171, "right", "5.000", true],
        "point_8": [15, 219, "right", "2.500", true],
        "point_9": [15, 267, "right", "1.000", true],
        "point_10": [15, 315, "right", "500", true],
        "point_11": [15, 363, "right", "300", true],
        "point_12": [130, 171, "right", "200", true],
        "point_13": [130, 219, "right", "150", true],
        "point_14": [130, 267, "right", "100", true],
        "point_15": [130, 315, "right", "90", true],
        "point_16": [130, 363, "right", "80", true],
        "point_17": [240, 267, "right", "70", true],
        "point_18": [240, 315, "right", "60", true],
        "point_19": [240, 363, "right", "50", true],
        "point_20": [456, 267, "left", "40", true],
        "point_21": [456, 315, "left", "30", true],
        "point_22": [456, 363, "left", "25", true],
        "point_23": [566, 171, "left", "20", true],
        "point_24": [566, 219, "left", "15", true],
        "point_25": [566, 267, "left", "10", true],
        "point_26": [566, 315, "left", "9", true],
        "point_27": [566, 363, "left", "8", true],
        "point_28": [681, 75, "left", "7", true],
        "point_29": [681, 123, "left", "6", true],
        "point_30": [681, 171, "left", "5", true],
        "point_31": [681, 219, "left", "4", true],
        "point_32": [681, 267, "left", "3", true],
        "point_33": [681, 315, "left", "2", true],
        "point_34": [681, 363, "left", "1", true]
    };

    var pointNumber = 1;
    for (var key in points) {
        if (typeof points[key] === 'object')
            scene.add(
                    new classPoints()
                    .setPointNumber(pointNumber)
                    .setDrumPoint(points[key][4])
                    .setText(points[key][3])
                    .setTextOrientation(points[key][2])   // must be executed before setImageX and setImageY
                    .setImage(images[mode + '_ball_holder'])
                    .setImageSize(54)
                    .setImageX(points[key][0])
                    .setImageY(points[key][1]),
                    key // important!!!
                    );
        pointNumber++;
    }

    scene.add(new classBigBall(), 'bigBall', true);
    
    colorBettingHolders = new Array();
    for (var x = 620; x < 620 + (8 * 15); x += 15) {
        colorBettingHolders.push(new classColorBetting()
                .setX(x)
                .setY(67)
                );    
    }

    oddNumbersHolders = new Array();
    for (var x = 320; x > 320 - (18 * 11); x -= 11) {
        oddNumbersHolders.push(new classOddEven()
                .setX(x)
                .setY(425)
                );
        
        scene.add(new classImage(images[mode + '_hole'])
                .setX(x)
                .setY(425),
                'hole_' + x
                );        
    }

    evenNumbersHolders = new Array();
    for (var x = 420; x < 420 + (18 * 11); x += 11) {
        evenNumbersHolders.push(new classOddEven()
                .setX(x)
                .setY(425)
                );
        
        scene.add(new classImage(images[mode + '_hole'])
                .setX(x)
                .setY(425),
                'hole_' + x
                );        
    }

    // show odd counter
    scene.add(new classText()
            .setX(334)
            .setY(435)
            .setFontSize('11px')
            .setFontFamily('FuturaHeavy')
            .setText('0'),
            'odd_counter');

    // show even counter
    scene.add(new classText()
            .setX(405)
            .setY(435)
            .setFontSize('11px')
            .setFontFamily('FuturaHeavy')
            .setText('0'),
            'even_counter');

    game.initialize();
}

function getKeyByValue(object, value) {
  return Object.keys(object).find(key => object[key] === value);
}

function resolveGameDisplayFromResponse(response) {
    if (!response || !response.Data) {
        return null;
    }
    if (response.Data.BingoGameDisplay && response.Data.BingoGameDisplay[0]) {
        return response.Data.BingoGameDisplay[0];
    }
    return null;
}

function getActiveGameState(fetchedGame) {
    var base = fetchedGame || responseHandler.getGame || {};
    var gameplay = window.__luckyballsV4Gameplay;
    if (gameplay) {
        return Object.assign({}, base, gameplay);
    }
    return base;
}

function isGameDrawInProgress(game) {
    if (String(window.currentGameDisplayStatus) === '1') {
        return true;
    }
    if (!game) {
        return false;
    }
    if (String(game.GameStatus) === '1') {
        return true;
    }
    if (game.GameNumbers && game.GameTimerResult != null) {
        var maxTimer = window.GameTimerResult;
        if (maxTimer == null && game.InitialGameTimerResult != null) {
            maxTimer = game.InitialGameTimerResult;
        }
        if (maxTimer != null) {
            var remaining = Number(game.GameTimerResult);
            var max = Number(maxTimer);
            if (!isNaN(remaining) && !isNaN(max) && max > remaining) {
                var numbers = game.GameNumbers.split('|').filter(function(e) {
                    return e !== '' && e != null;
                });
                if (numbers.length >= 5) {
                    return true;
                }
            }
        }
    }
    return false;
}

/** V4 results panel: hide current round only while draw is in progress. */
function getV4ResultsExcludeGameId(game) {
    var activeGame = getActiveGameState(game);
    if (!activeGame || activeGame.ID_Today == null || activeGame.ID_Today === '') {
        if (isGameDrawInProgress(activeGame) && window.activeTicketsRoundId) {
            return String(window.activeTicketsRoundId);
        }
        return '';
    }
    if (isGameDrawInProgress(activeGame)) {
        return String(activeGame.ID_Today);
    }
    return '';
}

function refreshResultsPanelFromCache() {
    if (!responseHandler.gameResults) {
        return;
    }
    var activeGame = getActiveGameState(responseHandler.getGame);
    resultsParse(
        responseHandler.gameResults,
        getV4ResultsExcludeGameId(activeGame),
        activeGame && activeGame.GameStatus != null ? activeGame.GameStatus : null,
        true
    );
}

window.refreshResultsPanelFromCache = refreshResultsPanelFromCache;

function fetchGameDisplayV4() {
    return new Promise(function(resolve) {
        apiSend(
            '/luckyballs/game/get',
            {},
            function(response) {
                resolve(response);
            },
            function() {
                resolve(null);
            }
        );
    });
}

function ensureGameTimerResult() {
    return new Promise(function(resolve) {
        if (window.GameTimerResult != null) {
            resolve(window.GameTimerResult);
            return;
        }
        apiSend(
            '/luckyballs/game/get/config',
            {},
            function(response) {
                if (response && response.Data && response.Data.BingoGame && response.Data.BingoGame[0]) {
                    window.GameTimerResult = response.Data.BingoGame[0].GameTimerResult;
                }
                resolve(window.GameTimerResult);
            },
            function() {
                resolve(null);
            }
        );
    });
}

function loadResultsPanel(excludeGameId, gameStatus, dispatchCredit) {
    return fetch(window['API_URL'] + '/luckyballs/game/results', {
        method: 'post',
        body: JSON.stringify({})
    }).then(function(response) {
        return response.json();
    }).then(function(resultsResp) {
        responseHandler.gameResults = resultsResp;
        if (dispatchCredit) {
            window.dispatchEvent(new CustomEvent("get_credit"));
        }
        resultsParse(resultsResp, excludeGameId, gameStatus, true);
    });
}

window.updateResults = () => {
    fetch(window['API_URL'] + '/luckyballs/game/results', {
        method: 'post',
        body: JSON.stringify({})
    }).then(function(response) {
        return response.json();
    }).then(function(resultsResp) {
        responseHandler.gameResults = resultsResp;
        window.dispatchEvent(new CustomEvent("get_credit"));
        resultsParse(resultsResp,responseHandler.getGame.ID_Today);
        chekingGameStatus();
    });
}

window.updateResultsV4 = function() {
    ensureGameTimerResult().then(function() {
        return fetchGameDisplayV4();
    }).then(function(gameResp) {
        var game = resolveGameDisplayFromResponse(gameResp);
        if (game) {
            responseHandler.getGame = Object.assign({}, responseHandler.getGame || {}, game);
            if (game.GameStatus != null) {
                window.currentGameDisplayStatus = game.GameStatus;
            }
        }

        var activeGame = getActiveGameState(game);
        return loadResultsPanel(
            getV4ResultsExcludeGameId(activeGame),
            activeGame && activeGame.GameStatus != null ? activeGame.GameStatus : null,
            false
        );
    });
};

apiSend = function(uri, json, successCallback, errorCallback) {
    $.ajax({
           url: window['API_URL'] + uri,
           type: "post",
           data: json ,
           success: function (response) {
              successCallback(response);
           },
           error: function(jqXHR, textStatus, errorThrown) {
              errorCallback(jqXHR, textStatus, errorThrown);
           }
       });
}

scheduleDrawings = function(toBeDrawn) {
        window['drawingInterval'] = setInterval(function(){
            if(parseInt(toBeDrawnCounter) < Object.keys(toBeDrawn).length) {
                game.extractBall(parseInt(toBeDrawn[toBeDrawnCounter]));
                toBeDrawnCounter ++;
            } else {
                clearInterval(window['drawingInterval']);
                results();
            }
        }, window['drawInterval'] * 1000);
}

displayJackpot = function(value) {
  if (V4 == 3 && location.host == 'online.weldmag.elbet.com') {
    $('#jackpotDisplay').text(translation['weldmag_jackpot'].toUpperCase() + ' : ' + value);
    return;
  }
    $('#jackpotDisplay').text(translation['jackpot'].toUpperCase() + ' : ' + value);
}

displayRegionalJackpot = function(value) {
    // Check if exist (exist only for domain where regionalJP is enabled)
    var regionalJackpotDOM = document.getElementById('regionalJackpotDOM');
    if (regionalJackpotDOM !== null) {
        regionalJackpotDOM.innerHTML = value;
        console.log("jackPotDetails.regionJackpotValue => ", value);
    }
}

/**
 * @description Main handler
 */
refresh = function() {

    // Hide jackpot div HOT FIX for termminal case.
    if (document.querySelector('.jackpot-informer') != null) {
      document.querySelector('.jackpot-informer').style.display = 'none';
    }

    apiSend(
        '/luckyballs/game/get',
        {},
        function(response) {

            var game = response['Data']['BingoGameDisplay'][0];
            responseHandler.getGame = response.Data.BingoGameDisplay[0];
            updateResults();

            if(typeof window['useJackpot'] !== 'undefined' &&
               responseHandler.getGame.Bingo_JackpotValue != '' &&
               responseHandler.getGame.Bingo_JackpotValue != null &&
               typeof responseHandler.getGame.Bingo_JackpotValue !== 'undefined') {
                if(window['useJackpot'] == true) {
                    displayJackpot(responseHandler.getGame.Bingo_JackpotValue);
                }

                if (typeof game['Region_JackpotValue'] !== 'undefined') {
                    displayRegionalJackpot(game['Region_JackpotValue']);
                } else {
                    displayRegionalJackpot("Not activated")
                }
            }

            window['globalCurrentGameId'] = game.ID_Today;
            if (String(game.GameStatus) === '1' && typeof window['bindLuckyBallsDrawRound'] === 'function') {
                window['bindLuckyBallsDrawRound'](game.ID_Today);
            }
            checkForJackpot(game);

        },
        function(jqXHR, textStatus, errorThrown) {
          // console.log("log ->", textStatus)
        }
    );
}

var chekingGameStatus = function() {

    switch(responseHandler.getGame.GameStatus) {
        case 0:
            if(responseHandler.getGame.GameTimer < 3) {

                responseHandler.getGame.GameTimer = 3;

            } else {

                // console.log('showing bet screen');
                betScreen(responseHandler.getGame.GameTimer);
                resultsParse(responseHandler.gameResults,responseHandler.getGame.ID_Today);

            }
            
            clearTimeout(window['refreshTimeout']);
            window['refreshTimeout'] = setTimeout(refresh, responseHandler.getGame.GameTimer * 1000);
            break;
        case 1:
            setTimeout(function() {
                let ticketShareImgs = document.querySelectorAll('.ticket-share-image');
                if (ticketShareImgs.length > 0) {
                    for (var ct = 0; ct <ticketShareImgs.length; ct ++) {
                        ticketShareImgs[ct].classList.add('showShare');
                    }
                }
            }, 1000);
            
            var numbers = responseHandler.getGame.GameNumbers.split("|");

            if(Object.keys(numbers).length < 5) {
                clearTimeout(window['refreshTimeout']);
                window['refreshTimeout'] = setTimeout(refresh, 2000);
                return;
            }

            numbers.shift();
            numbers.pop();
            var alreadyDrawnCount = Math.floor((window['GameTimerResult'] - responseHandler.getGame.GameTimerResult) / window['drawInterval']);
            if(alreadyDrawnCount > 35) {
                alreadyDrawnCount = 35;
            }
            
            var alreadyDrawn = numbers.slice(0,alreadyDrawnCount);
            var toBeDrawn = numbers.slice(alreadyDrawnCount, Object.keys(numbers).length);
            
            var bonusballs = responseHandler.getGame.GameBonusCounters.split("|");
            bonusballs.shift();
            bonusballs.pop();
            
            window['state'] = {};
            state.bonusballs = bonusballs.map(function(item) {
                return parseInt(item, 10);
            });
            
            state.balls = alreadyDrawn.map(function(item) {
                return parseInt(item, 10);
            });
            state.GameJackPotCode = responseHandler.getGame.GameJackPotCode;
            state.roundid_today = responseHandler.getGame.ID_Today;
            if (typeof window['bindLuckyBallsDrawRound'] === 'function') {
                window['bindLuckyBallsDrawRound'](state.roundid_today);
            }
            
            window['toBeDrawnCounter'] = 0;
            
            clearInterval(window['drawingInterval']);
            
            if(alreadyDrawnCount == 35) {
                if(responseHandler.getGame.GameTimerResult >= 4) {
                    // console.log('showing results screen');
                    window['drawnNumbers'] = state.balls;
                    results();
                } else {
                    console.log('No enough time for video. Show nothing.');
                }
            } else {
                if(responseHandler.getGame.GameTimerResult >= 4) {
                    if(responseHandler.getGame.HappyGame == true) {
                        // console.log('showing game progress screen - bonus');
                        gameProgress('bonus_yellow');
                    } else {
                        // console.log('showing game progress screen - regular');
                        gameProgress('regular_game');
                    }
                    scheduleDrawings(toBeDrawn);
                } else {
                    console.log('No enough time for game progress. Show nothing');
                }
            }
            
            if(responseHandler.getGame.GameTimerResult < 3) {
                responseHandler.getGame.GameTimerResult = 3;
            }
            
            clearTimeout(window['refreshTimeout']);
            window['refreshTimeout'] = setTimeout(refresh, responseHandler.getGame.GameTimerResult * 1000)
        break;
    default:
        console.error('invalid status')
    }

}

start = function() {

    try {

        // all assets loaded
        if (counter == loaded) {

            game = new classGame();

            // dynamically create big ball images
            for (var color in balls.colors) {
                for (var x = 0; x <= 24; x++) {
                    var img = images['big_ball_' + color][x];
                    var colorizeImage = new classColorizeImage(color);
                     // colorize all except black ball
                    var imgProcessed = (color != 'black') ? colorizeImage.getAnimationImage(img) : img;
                    images['big_ball_' + color][x] = imgProcessed;
                }
            }

            // initialize canvas once
            canvas = new classCanvas();
            canvas.initialize();
            canvas.clear();
            canvas.loop();

            apiSend(
                '/luckyballs/game/get/config',
                {},
                function(response){
                    var game = response['Data']['BingoGame'][0];
                    window['GameTimerResult'] = game['GameTimerResult'];
                    refresh();
                },
                function(jqXHR, textStatus, errorThrown){
                    // empty
                });

        } else {
            setTimeout(start, 200);
        }

    } catch (error) {
        console.log(error);
    }
}

preload = function() {

    try {

        var self = this;
        counter = 0;
        loaded = 0;

        this.format = function(num, places) {
            var zero = places - num.toString().length + 1;
            return Array(+(zero > 0 && zero)).join("0") + num;
        }

        /**
         * @Description IMPROVEMENTS
         */
        images = new Object();

        sources = {
            'regular_game_header': 'img/regular_game/' + window['LogoURL'],
            'regular_game_footer': 'img/regular_game/footer.png',
            'regular_game_ball_holder': 'img/regular_game/ball_holder.png',
            'regular_game_background': 'img/regular_game/background.png',
            'regular_game_number_picked': 'img/regular_game/number_picked.png',
            'regular_game_check_infobar': new Array(),
            'regular_game_hole': 'img/regular_game/hole.png',
            'bonus_yellow_header': 'img/bonus_yellow/' + window['LogoURL'],
            'bonus_yellow_footer': 'img/bonus_yellow/footer.png',
            'bonus_yellow_ball_holder': 'img/bonus_yellow/ball_holder.png',
            'bonus_yellow_background': 'img/bonus_yellow/background.png',
            'bonus_yellow_number_picked': 'img/bonus_yellow/number_picked.png',
            'bonus_yellow_check_infobar': new Array(),
            'bonus_yellow_hole': 'img/bonus_yellow/hole.png',
            'bonus_green_header': 'img/bonus_yellow/' + window['LogoURL'],
            'bonus_green_footer': 'img/bonus_green/footer.png',
            'bonus_green_ball_holder': 'img/bonus_green/ball_holder.png',
            'bonus_green_background': 'img/bonus_green/background.png',
            'bonus_green_number_picked': 'img/bonus_green/number_picked.png',
            'bonus_green_check_infobar': new Array(),
            'bonus_green_hole': 'img/bonus_green/hole.png',
            'drum_frame': 'img/drum/frame.png',
            'drum_loop': new Array(),
            'drawn_balls': new Object(),
            'infobox': new Array(),
            'color_betting': 'img/colorBetting.png',
            'header_intro': 'img/header-intro.png',
            'jackpot': new Array(),
            'flower': 'img/flower.png',
            'color_betting_black' : 'img/color_betting/black.png',
            'color_betting_blue' : 'img/color_betting/blue.png',
            'color_betting_brown' : 'img/color_betting/brown.png',
            'color_betting_green' : 'img/color_betting/green.png',
            'color_betting_orange' : 'img/color_betting/orange.png',
            'color_betting_red' : 'img/color_betting/red.png',
            'color_betting_yellow' : 'img/color_betting/yellow.png',
            'color_betting_purple' : 'img/color_betting/purple.png',
        }

        // big and small balls resources
        balls = new classBalls('small');

        // jackpot
        for (var x = 1; x <= 19; x++) {
            sources['jackpot'].push('img/jackpot/' + this.format(x, 3) + '.png')
        }

        // check infobar
        for (var x = 1; x <= 15; x++) {
            sources['regular_game_check_infobar'].push('img/regular_game/check_infoBar/check_' + this.format(x, 3) + '.png')
        }

        // check infobar
        for (var x = 1; x <= 15; x++) {
            sources['bonus_yellow_check_infobar'].push('img/bonus_yellow/check_infoBar/check_' + this.format(x, 3) + '.png')
        }

        // check infobar
        for (var x = 1; x <= 15; x++) {
            sources['bonus_green_check_infobar'].push('img/bonus_green/check_infoBar/check_' + this.format(x, 3) + '.png')
        }

        // drum animation
        for (var x = 1; x < 42; x++) {
            sources['drum_loop'].push('img/drum/drum_loop_' + this.format(x, 3) + '.png');
        }

        // drawn balls
        for (var color in balls.colors) {

            sources['drawn_ball_' + color] = 'img/drawnballs/' + color + '.png';
        }

        for (var x = 1; x < 30; x++) {
            sources['infobox'].push('img/infobox/info_Box_' + this.format(x, 3) + '.png');
        }

        for (var color in balls.colors) {

            sources['big_ball_' + color] = new Array();
            for (var x = 1; x <= 25; x++) {
                sources['big_ball_' + color].push('img/bigball/BigBall_' + this.format(x, 3) + '.png')
            }
        }

        // convert sources to image objects
        for (var src in sources) {

            if (typeof sources[src] == 'object') {

                images[src] = new Array();
                for (var subitem in sources[src]) {
                    // count total number of images to be loaded
                    counter++;
                    var tempImg = new Image();
                    tempImg.src = sources[src][subitem];
                    tempImg.addEventListener('load', function() {
                        loaded++;
                    });
                    images[src].push(tempImg);
                }
            } else {
                // count total number of images to be loaded
                counter++;
                images[src] = new Image();
                images[src].src = sources[src];
                images[src].addEventListener('load', function() {
                    loaded++;
                });
            }

        }

        start();

    } catch (error) {
        console.log(error);
    }
}

window['gameDisplayV4'] = function(resp) {
    checkForJackpot(resp);
}



//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/js/luckyballs.js
// module id = 874
// module chunks = 0